import React from 'react';

const DOC_REF_REGEX = /([{[])\s*([a-zA-Z][a-zA-Z0-9/.\s]*[0-9])\s*([\]}])/g;

export function renderTextWithDocRefs(
  text: string,
  onDocRefClick: (refText: string) => void,
): React.ReactNode {
  DOC_REF_REGEX.lastIndex = 0;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = DOC_REF_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const fullMatch = match[0];
    const innerText = match[2].replace(/\s/g, '');
    const offset = match.index;

    parts.push(
      <span
        key={offset}
        className="real-time__doc-ref"
        role="link"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          onDocRefClick(innerText);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.stopPropagation();
            onDocRefClick(innerText);
          }
        }}
      >
        {fullMatch}
      </span>,
    );

    lastIndex = match.index + fullMatch.length;
  }

  if (parts.length === 0) return text;

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}
